export const LEADERBOARD_KEY = 'leaderBoard';
export const LEADERBOARD_WITH_SCORES_KEY = 'leaderboardWithScores';
export const ACTIVITY_LOG_KEY = 'activityLog';
export const getLeaderboardKey = (args) => [
    LEADERBOARD_KEY,
    args,
];
export const getLeaderboardWithScoresKey = (args) => args ? [LEADERBOARD_WITH_SCORES_KEY, args] : [LEADERBOARD_WITH_SCORES_KEY];
export const getActivityLogKey = (args) => args ? [ACTIVITY_LOG_KEY, args] : [ACTIVITY_LOG_KEY];
//# sourceMappingURL=report.keys.js.map